import { SEARCH_MODAL_ITEM_KIND } from '@common/components/SearchModal/search-modal.const'

import type { AcademySearchApiItem } from '@/lib/academySearch/academySearch.interface'
import { ACADEMY_ROUTES } from '@/shared/academy.const'

export function mapGlossary(row: AcademySearchApiItem, _queryTrimmed: string) {
  return {
    id: `glossary-${row.path}`,
    title: row.title,
    href: `${ACADEMY_ROUTES.glossary}#${row.slug}`,
    kind: SEARCH_MODAL_ITEM_KIND.Glossary,
  }
}
